
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class CustomerService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.cus_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_CUSTOMER_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }

  static getCustomerPageList(input, responseCallBack, errorCallBack) {
    this.method("getCustomerPageList", input, responseCallBack, errorCallBack);
  }
  static readCustomer(input, responseCallBack, errorCallBack) {
    this.method("readCustomer", input, responseCallBack, errorCallBack);
  }
  static createCustomer(input, responseCallBack, errorCallBack) {
    this.method("createCustomer", input, responseCallBack, errorCallBack);
  }
  static updateCustomer(input, responseCallBack, errorCallBack) {
    this.method("updateCustomer", input, responseCallBack, errorCallBack);
  }
  static initCustomer(input, responseCallBack, errorCallBack) {
    this.method("initCustomerModule", input, responseCallBack, errorCallBack);
  }
  static unLockCustomer(input, responseCallBack, errorCallBack) {
    this.method("unLockCustomer", input, responseCallBack, errorCallBack);
  }
  static saveCustomerShipTo(input, responseCallBack, errorCallBack) {
    this.method("saveCustomerShipTo", input, responseCallBack, errorCallBack);
  }
  static updateCustomerShipTo(input, responseCallBack, errorCallBack) {
    this.method("updateCustomerShipTo", input, responseCallBack, errorCallBack);
  }
  static saveCustomerBillTo(input, responseCallBack, errorCallBack) {
    this.method("saveCustomerBillTo", input, responseCallBack, errorCallBack);
  }
  static updateCustomerBillTo(input, responseCallBack, errorCallBack) {
    this.method("updateCustomerBillTo", input, responseCallBack, errorCallBack);
  }
  static getCustomerBillToPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getCustomerBillToPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerWithChildren(input, responseCallBack, errorCallBack) {
    this.method(
      "readCustomerWithChildren",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerSalesOnOrderDetailsForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerSalesOnOrderDetailsForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static removeCustomerShipTo(input, responseCallBack, errorCallBack) {
    this.method("removeCustomerShipTo", input, responseCallBack, errorCallBack);
  }
  static getCustomerSalesPersonCommissionPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerSalesPersonCommissionPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerSalesPersonCommission(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readCustomerSalesPersonCommission",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static removeCustomerSalesPersonCommission(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "removeCustomerSalesPersonCommission",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static saveCustomerSalesPersonCommission(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "saveCustomerSalesPersonCommission",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCustomerSalesPersonCommission(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateCustomerSalesPersonCommission",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerCreditCardsPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerCreditCardsPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerCreditCard(input, responseCallBack, errorCallBack) {
    this.method(
      "readCustomerCreditCard",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static removeCustomerCreditCard(input, responseCallBack, errorCallBack) {
    this.method(
      "removeCustomerCreditCard",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCustomerCreditCard(input, responseCallBack, errorCallBack) {
    this.method(
      "updateCustomerCreditCard",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCustomerCreditCard(input, responseCallBack, errorCallBack) {
    this.method(
      "createCustomerCreditCard",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCustomerFabricStyleReferenceBean(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createCustomerFabricStyleReferenceBean",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerFabricStyleReferences(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readCustomerFabricStyleReferences",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static syncCustomerFabricStyleReferenceBean(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "syncCustomerFabricStyleReferenceBean",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCustomerFabricStyleReferenceBean(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateCustomerFabricStyleReferenceBean",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerSalesOnOrderDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerSalesOnOrderDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerWithBillTosAndShipTos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readCustomerWithBillTosAndShipTos",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerShipToPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getCustomerShipToPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCustomerUser(input, responseCallBack, errorCallBack) {
    this.method("createCustomerUser", input, responseCallBack, errorCallBack);
  }
  static readCustomerPriceForService(input, responseCallBack, errorCallBack) {
    this.method(
      "readCustomerPriceForService",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerServices(input, responseCallBack, errorCallBack) {
    this.method("readCustomerServices", input, responseCallBack, errorCallBack);
  }
  static getCustomerLogisticOnOrderDetailsForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerLogisticOnOrderDetailsForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerExcludesMasterCustomer(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerExcludesMasterCustomer",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getCustomerShipTosAndAttributeShipTos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerShipTosAndAttributeShipTos",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  
    static updateCustomerUser(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateCustomerUser",
      input,
      responseCallBack,
      errorCallBack
    );
  }

    static getCustomerUserPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerUserPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }

    static readCustomerUser(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readCustomerUser",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  
  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.cus_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
      ServiceExecutorProxy.executeService(methodName, input,this.cus_data_url,responseCallBack, errorCallBack);
    }
  }
}
